/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DownpaymentComplete/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ContinueAction from './ContinueAction/index'
import React from 'react'
import Steps from './Steps/index'
import TysiaIconCheckFilled from 'DesignSystem/Svgs/TysiaIconCheckFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DownpaymentComplete({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentComplete"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsGreen800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.800'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<Steps
  viewPath={`${viewPath}/Steps`}
/>
<div
  data-testid="DownpaymentComplete.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-ZdIC7F': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="DownpaymentComplete.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaIconCheckFilled
  viewPath={`${viewPath}/TysiaIconCheckFilled`}
 width={40}
 fill2={dtColorsGreen800}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingTop={dtSpaceM}
 paddingBottom={dtSpaceXs}
 color={dtColorsNeutral900}
 text="Downpayment is successful."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Continue to setup payment for installments"
/>
</div>
<div
  data-testid="DownpaymentComplete.Vertical:2"
  data-view-path={viewPath}
 borderTopRadius={1}
 style={{'--btc-2-ZdIC7F': dtColorsNeutral200,'--pt-1-ZdIC7F': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-ZdIC7F': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<ContinueAction
  viewPath={`${viewPath}/ContinueAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}